import {
  AssetIcon,
  DocumentIcon,
  ArtifactIcon,
  TaskIcon,
  TicketIcon,
} from "@components/icons";
import {Paginator} from "@components/Paginator";
import {Pageable, SearchResult} from "@core/model";
import {Box, ButtonBase, Stack, Typography} from "@mui/material";

const SearchResultsTable = ({
  data,
  onRowClick,
  onPageChange,
  onRowsPerPageChange,
}: {
  data: Pageable<SearchResult>;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
  onRowClick: (item: SearchResult) => void;
}) => {
  const renderIcon = (item: SearchResult) => {
    switch (item.type) {
      case "ASSET":
        return <AssetIcon />;
      case "TASK":
        return <TaskIcon />;
      case "DOCUMENT":
        return <DocumentIcon />;
      case "TICKET":
        return <TicketIcon />;
      case "ARTIFACT":
        return <ArtifactIcon />;
    }
  };
  return (
    <>
      <Stack flex={"1 1 0"} gap={1} overflow={"auto"}>
        {data.content.map(item => (
          <ButtonBase
            key={`search-result-${item.id}`}
            onClick={() => onRowClick(item)}
            sx={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 2,
              py: 1,
            }}>
            {renderIcon(item)}
            <Typography>{item.name}</Typography>
          </ButtonBase>
        ))}
        <Box height={200} />
      </Stack>
      <Paginator
        page={data.number}
        rowsPerPage={data.size}
        count={data.totalElements}
        onPageChange={(e, page) => onPageChange(page)}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </>
  );
};

export {SearchResultsTable};
